var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._l((_vm.rate),function(a,key){return _c('v-icon',{key:a},[_vm._v("star")])}),_vm._v(" "),_vm._l(((_vm.max - _vm.rate)),function(i,key){return _c('v-icon',{key:(i + "-" + _vm.max)},[_vm._v("star_border")])})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-25002fb8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/watcheezy/WzRating.vue
// module id = null
// module chunks = 